import { IsString, IsOptional, IsBoolean, IsUUID } from 'class-validator';

export class CreateWarehouseProductManagementRequestDto {
    /**
     * Warehouse Detail ID reference
     * @example '123e4567-e89b-12d3-a456-426614174000'
     */
    @IsUUID()
    warehouseDetailId!: string;

    /**
     * Primary status control method
     * @example 'ElectronicWMS'
     */
    @IsOptional()
    @IsString()
    statusControlPrimary?: string;

    /**
     * Name of WMS system
     * @example 'Robocom customized'
     */
    @IsOptional()
    @IsString()
    wmsSystemName?: string;

    /**
     * SOP/Reference for placard control
     * @example 'W3-02'
     */
    @IsOptional()
    @IsString()
    placardControlRef?: string;

    /**
     * New product setup process
     * @example 'Item setup process description'
     */
    @IsOptional()
    @IsString()
    newProductSetupProcess?: string;

    /**
     * Storage Ambient 15-30C
     * @example true
     */
    @IsOptional()
    @IsBoolean()
    storageAmbient15_30C?: boolean;

    /**
     * Storage Ambient 15-25C
     * @example false
     */
    @IsOptional()
    @IsBoolean()
    storageAmbient15_25C?: boolean;

    /**
     * Storage Cold Chain 2-8C
     * @example true
     */
    @IsOptional()
    @IsBoolean()
    storageColdChain2_8C?: boolean;

    /**
     * Storage Aerosol Cage
     * @example false
     */
    @IsOptional()
    @IsBoolean()
    storageAerosolCage?: boolean;

    /**
     * Storage Controlled Drug Cage
     * @example false
     */
    @IsOptional()
    @IsBoolean()
    storageControlledDrugCage?: boolean;

    /**
     * Description if Other storage is used
     * @example 'Special storage conditions'
     */
    @IsOptional()
    @IsString()
    storageOtherDesc?: string;

    /**
     * Product tracking unit (Unit, Case, EA, ReferToWMS)
     * @example 'Case'
     */
    @IsOptional()
    @IsString()
    productTrackingUnit?: string;

    /**
     * System printouts provided on receipt?
     * @example true
     */
    @IsOptional()
    @IsBoolean()
    wmsScreenshotOnReceipt?: boolean;

    /**
     * System printouts provided on disposition?
     * @example true
     */
    @IsOptional()
    @IsBoolean()
    wmsScreenshotOnDisposition?: boolean;

    /**
     * Has quarantine area
     * @example true
     */
    @IsOptional()
    @IsBoolean()
    hasQuarantineArea?: boolean;

    /**
     * Has cold storage
     * @example true
     */
    @IsOptional()
    @IsBoolean()
    hasColdStorage?: boolean;

    /**
     * Has humidity control
     * @example true
     */
    @IsOptional()
    @IsBoolean()
    hasHumidityControl?: boolean;

    /**
     * Inventory on ZenQMS
     * @example true
     */
    @IsOptional()
    @IsBoolean()
    inventoryOnZenQms?: boolean;

    /**
     * Notes
     * @example 'Additional security measures in place'
     */
    @IsOptional()
    @IsString()
    notes?: string;
}
